export default __webpack_public_path__ + "media/color/poa-dfe1a59a.svg";